import React from "react";
import { css } from "react-emotion";

const tabContainer = css`
  display: flex;
  flex-direction: row;
  height: 40px;
  padding: 0px;
  width: fit-content;
`;

const tabItem = css`
  border: 0.5px solid #f1f1f1;
  min-width: 100px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  background: white;
  color: #acdfe0;

  &:hover {
    background: #f1f1f1;
  }
`;

function TabSelector({ tabs, style, current }) {
  return (
    <div className={tabContainer} style={style}>
      {tabs.map((tab) => {
        const { text, value, onClick } = tab;

        const selected = current === value;

        return (
          <div
            className={tabItem}
            onClick={onClick}
            style={{
              background: selected && "#f1f1f1",
            }}
          >
            {text}
          </div>
        );
      })}
    </div>
  );
}

export default TabSelector;
